export default __webpack_public_path__ + "static/media/large-ellipse.3654d977.svg";